<template>
  <BoxGenericsTable />
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import BoxGenericsTable from '@/components/deepbox/box/BoxGenericsTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.box.generic_folders',
  },
})

const { permissions } = useAuthorizationContext()

usePageAccess(computed(() => !permissions.canViewBoxes))
</script>
